export const API_BASE = process.env.PUBLIC_API_SENTINEL || 'http://localhost:3000/api/v1';
export const VERIFICATION_REPORT_URL =
	process.env.PUBLIC_VERIFICATION_REPORT_URL || 'https://sponsored-content.svc.trueflag.ai/verification_report';
export const PHASES = ['detect', 'verify', 'respond'] as const;

export const ROLES = {
	UNDEFINED: 'undefined',
	FACT_CHECKER: 'fact-checker',
	DOCUMENTALIST: 'documentalist',
	JOURNALIST: 'journalist',
	COORDINATOR: 'coordinator',
	COMMUNITY_MANAGER: 'community-manager'
} as const;

export const SENTINEL_SSE_EVENTS = {
	STATUS_CHANGE: 'status_change',
	VIDEO_ANALYSIS: 'video_analysis',
	EVALUATED_CLAIMS: 'evaluated_claims',
	ERROR: 'error'
} as const;

export const CONCLUSION_ICON_MAP = {
	TRUE: 'icon-check',
	FALSE: 'icon-cross',
	MISLEADING: 'icon-exclamation',
	UNCLEAR: 'icon-question'
};

export const SSE_CONFIG = {
	MAX_RETRIES: 3,
	RETRY_DELAY_MS: 2000,
	CONNECTION_TIMEOUT_MS: 300000
};

export const TIKTOK_URL_REGEX = /^https?:\/\/(www\.)?(tiktok\.com|vm\.tiktok\.com)/;
// Canonical TikTok video URL accepted by the processing pipeline: https://www.tiktok.com/@user/video/<id>
export const TIKTOK_VIDEO_URL_REGEX = /^https:\/\/www\.tiktok\.com\/@[^/]+\/video\/(\d+)/;
export const YT_SHORTS_URL_REGEX = /^https?:\/\/(www\.)?youtube\.com\/shorts\//;
export const YT_WATCH_URL_REGEX = /^https?:\/\/(www\.)?youtube\.com\/watch\?v=/;

export const CONCLUSION_LOCALE_MAP: Record<string, string> = {
	true: 'true',
	verdadero: 'true',
	false: 'false',
	falso: 'false',
	uncertain: 'uncertain',
	incierto: 'uncertain',
	misleading: 'misleading',
	engañoso: 'misleading'
};
